export default {
	list: [
		{
			id: 0,
			code: "us",
			image: "/images/flags/us.png"
		},
		{
			id: 2,
			code: "pl",
			image: "/images/flags/pl.png"
		},
		{
			id: 3,
			code: "kz",
			image: "/images/flags/kz.png"
		},
	],
}
